import { cn } from '@/utlis/cn'
import { cardXPad } from './Card'

type FieldProps = {
    title: React.ReactNode
    children?: React.ReactNode
    className?: string
}
export function Field({ children, title, className }: FieldProps) {
    return (
        <div className={cn('w-full grid grid-cols-[30%_70%] gap-2 md:grid-cols-2', cardXPad, className)}>
            <div>{title}</div>
            <div>{children}</div>
        </div>
    )
}
